module.exports = __webpack_public_path__ + "static/media/discovery.3f0df4c0.svg";